'use client'

import { Card, Checkbox, Container, Spacer, Text } from '@vinted/web-ui'
import { useFormContext } from 'react-hook-form'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import RequiredValidation from '../RequiredValidation'
import { ProIntegrationsApplicationFormField } from '../constants'
import { ProIntegrationsApplicationFormModel } from '../types'

const TermsAndConditions = () => {
  const translate = useTranslate('business.pro_integrations_application.form.terms_and_conditions')
  const {
    register,
    formState: { errors },
  } = useFormContext<ProIntegrationsApplicationFormModel>()

  return (
    <Card>
      <Container styling={Container.Styling.Wide}>
        <Checkbox
          {...register(ProIntegrationsApplicationFormField.TermsOfUse, { required: true })}
          text={<Text as="span" html text={translate('terms_of_use')} />}
          testId="pro-integrations-application-form-terms-of-use"
        />
        {errors[ProIntegrationsApplicationFormField.TermsOfUse] && (
          <Spacer size={Spacer.Size.Medium} />
        )}
        <RequiredValidation
          error={errors[ProIntegrationsApplicationFormField.TermsOfUse]}
          type="terms_of_use_required"
          testId="pro-integrations-application-form-terms-of-use-validation"
        />
      </Container>
    </Card>
  )
}

export default TermsAndConditions
